var path = 'areas/shared/views/selector/choice-release.html';
var html = "<span ng-bind-html=\"item.Version | highlight: $select.search\"></span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/views/selector/choice-release.html
// module id = 1917872444291134
// module chunks = 1